import * as React from 'react'; 
import { connect } from 'react-redux';
import { fetchSellersFilter } from '../../actions/sellersActions'; 
import { setFiltroGrupoPlanes } from '../../actions/planesActions';
import { customStyleFilter } from '../../template/CustomStyle';
import Select from 'react-select';
import PropTypes from 'prop-types';

class FiltroGrupoPlanes extends React.Component{
    constructor (props){
        super(props); 
        this.estadoOptions = [
            { value: 0, label: 'VIGENTE' },
            { value: 2, label: 'DESHABILITADO' }
        ];
        this.state = {
            descripcion: this.props.filtro?.descripcion ?? "",
            numeroPagina: 1,
            cantidadPagina: 10,
            estado: this.estadoOptions.find(opt => opt.value === this.props.filtro?.estado) ?? null,
        }
    };

 
    myChangeHandler = async (e) =>{
        const { name, value } = e.target;
        this.setState({[name]: value});
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        this.props.getPlanes();
    }
    
    selectSearchHandler = (option, config) => {
        this.setState({ [config.name]: option });
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, [config.name]: option ? option.value : null });
    }

    verTodos=()=>{
        this.setState({ descripcion: "", estado: null });
        this.props.setFiltroGrupoPlanes({ descripcion: "", estado: null, numeroPagina: 1, cantidadPagina: 10 });
        this.props.clearFilter();
    }

    render(){
        
        return ( 
            <div className="card card-body filter-card admin-filter-panel">
                <form className="row justify-content-start align-items-center form-material"
                    onSubmit={this.onSubmit}
                    onReset={this.verTodos}
                >

                    <div className="col-12 col-sm-3">
                        <label htmlFor="descripcionFiltroGrupoPlanes" className="label-oscura">Descripción</label>
                        <input 
                            id="descripcionFiltroGrupoPlanes"
                            type="text" 
                            name="descripcion" 
                            value={this.state.descripcion} 
                            className="form-control" 
                            onChange={this.myChangeHandler} 
                        />
                    </div>
                    <div className="col-12 col-sm-3">
                        <label htmlFor="estadoFiltroGrupoPlanes" className="label-oscura">Estado</label>
                        <Select
                            id="estadoFiltroGrupoPlanes"
                            name="estado"
                            options={this.estadoOptions}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado}
                            styles={customStyleFilter}
                        />
                    </div>

                    <div className="col-12 col-sm-auto mt-2">
                        <div className="row justify-content-center justify-content-end">
                            <button 
                                type="submit"
                                className="btn btn-sm btn-grey d-inline col-auto mx-3"
                            >
                                Buscar
                            </button>
                            <button 
                                type='reset'
                                className="btn btn-sm btn-grey d-inline col-auto"
                            >
                                Limpiar
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        ); 
    }
}
FiltroGrupoPlanes.propTypes = {
    // Redux props
    filtro: PropTypes.oneOfType([PropTypes.shape({
        descripcion: PropTypes.string,
        estado: PropTypes.number,
    }), PropTypes.array]),
    // Actions props
    setFiltroGrupoPlanes: PropTypes.func,
    getPlanes: PropTypes.func,
    clearFilter: PropTypes.func,
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    sellers: state.sellers.filteredSellers,
    filtro: state.planes.filtro
});

export default connect(mapStateToProps, {fetchSellersFilter, setFiltroGrupoPlanes}) (FiltroGrupoPlanes);